import React, { useEffect } from "react";
import { useState } from 'react';
import { Link } from "react-router-dom";
import { Info, ArrowRight, ExternalLink, GraduationCap, Building2, FlaskConical, Globe, Target } from "lucide-react";
import "@google/model-viewer";
import AOS from "aos";
import "aos/dist/aos.css";
import "./MasAlla.css";
import { StripeLikeGradientShader } from "./ui/StripeLikeGradientShader";
import { GlassEffect, GlassFilter } from "./ui/LiquidGlass";



/* Recursos */
const heroBg = "/img/fondoMasAlla.png";
//const logoCanarias = "/img/logo_GobCan.png";
const logoCanarias = "/img/GobCan.png";
const logoEOI = "/img/logoeoiok.png";
const logoTop101 = "/img/logo-top-header.svg";
//const logoIPFest = "/img/IPFest.png";
const logoIPFest = "/img/IPFest2.png";
const logoFuncatra = "/img/Funcatra.png";
const logoProexca = "/img/Proexca.png";
const logoElReferente = "/img/ElReferente.png";
const logoENISA = "/img/Enisa.png";
//const logoTVC = "/img/Tvc.png";
//const logoULPGC = "/img/ULPGC.png";
//const logoULPGC = "/img/ULPGC_corto.png";
const logoTribunaDeCanarias = "/img/TribunaDeCanarias.png";
const logoCamaraDeComercioGC = "/img/CamaraComercioGC.png";
const logoBBVA = "/img/bbva.png";
const logoLaProvincia = "/img/LogoLaProvincia.png";
const logoRedCIDE = "/img/RedCide.png";
const logoCET = "/img/CanariasExcelenciaTecnologica.png";
const logoFEMETE = "/img/Femete.png";
const logoOficinaAceleraPyme = "/img/femepa.png";
const logoFemepa = "/img/Logo_Femepa.png";
const logoCofinanciadoEU = "/img/CofinanciadoEU.jpg";
const logoFondosEuropeos = "/img/FondosEuropeos.png";
const logoBEST = "/img/carousel34.png";
const logoAshotel = "/img/ashotel.png";
const logoMinisterioAgricultura = "/img/Ministerio.jpg";


/* Proyecto ejemplo */
const projects = [
  {
    category: "Nacionales",
    program: "CONVOCATORIA GO 2025",
    convocatoria: "2025",
    subvencion:
      "Proyectos de innovación de interés general por grupos operativos supraautonómicos (AEI-Agri) (PEPAC).",
    titulo: "Biocrass",
    link: "https://biocrass.sparklingtech.es/",
    logo: logoCofinanciadoEU,
    extraLogo: logoMinisterioAgricultura,
    ayuda:
      "Importe de ayuda 501.880.03€ cofinanciado al 80% por la Unión Europea a través del Plan Estratégico de la PAC - FEADER.",
    objetivo:
      "Revalorización de subproductos procedentes de especies con metabolismo crasuláceo presentes en Andalucía y Canarias para su uso en biocosmética, alimentación y agricultura.",
  },
  {
    category: "Nacionales",
    program: "Proyectos de innovación RIS3 ampliada",
    convocatoria: "Convocatoria de subvenciones para el ejercicio 2026 destinadas a empresas para la realización de proyectos de innovación en áreas prioritarias de la estrategia de especialización inteligente y sostenible de Canarias (RIS3+)",
    expediente: "EPIRIS2026010001",
    fechaInicio: "01/04/2026",
    duracion: "18 meses",
    subvencion:
      "Convocatoria de innovación en áreas prioritarias de la estrategia de especialización inteligente y sostenible de Canarias",
    titulo:
      "STAR-SAT",
    logo: logoCofinanciadoEU,
    extraLogo: logoFondosEuropeos,
    extraLogo2: logoCanarias,
    objetivo:
      "Sistema predictivo satelital de riesgo ambiental para la salud mental y el bienestar de población vulnerable",
  },
  {
    category: "Nacionales",
    program: "Programa Innovación Social (2026)",
    convocatoria: "2026",
    expediente: "ProIS2026010001",
    fechaInicio: "02/03/2026",
    duracion: "12 meses",
    subvencion:
      "Subvenciones destinadas a proyectos de innovación social, segundo procedimiento (2026).",
    titulo:
      "Little Challenge",
    logo: logoCanarias,
    objetivo:
      "Plataforma intergeneracional con Asistente Cognitivo Virtual y Patrimonio Vivo para reducir la soledad y el deterioro cognitivo en mayores de Canarias.",
  },
  {
    category: "Nacionales",
    program: "Programa STARS 2025",
    convocatoria: "2025",
    expediente: "IProIC2025010048",
    fechaInicio: "01/04/2025",
    duracion: "12 meses",
    subvencion:
      "Subvenciones públicas para el impulso de proyectos de innovación disruptiva en Canarias.",
    titulo:
      "NeuroGlint – Decodificando estímulos con tecnología de análisis avanzado.",
    logo: logoCanarias,
    objetivo:
      "Desarrollar NeuroGlint, una plataforma avanzada de neuromarketing que integre seguimiento de mirada, RV, análisis emocional e IA, centrada en la personalización y la accesibilidad para empresas de distintos sectores y tamaños. El proyecto posicionará a Canarias como laboratorio natural y referente tecnológico en neuromarketing.",
  },
];

/* ProyectoPremios ejemplo */
const projectsPremio = [
  {
    category: "Premios",
    program: "Top 101 Spain Up Nation",
    convocatoria: "2025",
    fechaInicio: "12/11/2025",
    titulo: "Reconocimientos TOP101 al Emprendimiento con Impacto en España.",
    logo: logoTop101,
    extraLogo: "/img/LOGOS-Extraa.png",
    objetivo: "Sparkling Tech Solutions finalista en los Reconocimientos TOP101 SPAIN UP NATION. El reconocimiento TOP101 —que distingue a las startups con mayor impacto, innovación y proyección en toda España, es un programa de reconocimiento público a empresas emergentes (startups) españolas con alto grado de innovación y capacidad de impacto social, económico y medioambiental"
  },
  {
    category: "Premios",
    program: "IPfest - Transferencia de Conocimiento",
    convocatoria: "2025",
    fechaInicio: "20/11/2025",
    titulo: "Mejor Startup Universitaria - Reconocimiento nacional y regional",
    logo: logoIPFest,
    extraLogo: null,
    objetivo: "Sparkling Tech Solutions fue galardonada como Startup Universitaria en los Premios Nacionales de Transferencia de Conocimiento IPfest 2025. Un reconocimiento nacional que refuerza nuestro compromiso con la transferencia de conocimiento, la innovación aplicada y el impacto social desde Canarias hacia todo el ecosistema tecnológico español."
  },
  {
    category: "Premios",
    program: "Programa de emprendimiento EOI–SPEGC",
    convocatoria: "2024",
    fechaInicio: "23/10/2024",
    titulo: "Demoday – Espacio CoWorking.",
    logo: logoEOI,
    extraLogo: "/img/spegc-logotipo-rgb-01.png",
    objetivo: "En Sparkling Tech Solutions hemos sido reconocidos, dentro del programa de emprendimiento EOI–SPEGC, un galardón que avala nuestro compromiso con la innovación tecnológica, el emprendimiento y el impacto positivo en la sociedad. Este reconocimiento pone en valor nuestra labor en el desarrollo de soluciones digitales avanzadas que transforman sectores como la salud, el bienestar y la agricultura. Con este logro, consolidamos nuestra posición como empresa de referencia en el ecosistema emprendedor y tecnológico de Canarias.",
  },
  {
    category: "Reconocimientos",
    program: "FUNCATRA - Estrategia de Apoyo al Empleo",
    convocatoria: "2025",
    fechaInicio: "18/12/2025",
    titulo: "Reconocimiento al impacto en empleo e innovación",
    logo: logoFuncatra,
    extraLogo: null,
    objetivo: "Sparkling Tech Solutions fue reconocida por FUNCATRA en la Estrategia de Apoyo al Empleo 2025 por su contribución al desarrollo económico y productivo de Canarias. Este reconocimiento avala nuestro compromiso con la innovación responsable, el empleo cualificado y el fortalecimiento del tejido empresarial regional."
  },
  {
    category: "Reconocimientos",
    program: "PROEXCA - Internacionalización",
    convocatoria: "2025",
    fechaInicio: "16/12/2025",
    titulo: "Caso de éxito en expansión internacional",
    logo: logoProexca,
    extraLogo: null,
    objetivo: "Sparkling Tech Solutions fue reconocida por PROEXCA como caso de éxito en internacionalización de empresas tecnológicas lideradas por mujeres. Nuestra experiencia refleja un modelo de crecimiento global basado en estrategia, innovación y transferencia de conocimiento desde Canarias a mercados internacionales."
  },
  {
    category: "Reconocimientos",
    program: "Top 25 Startups de IA - 2026",
    convocatoria: "2026",
    fechaInicio: "10/12/2025",
    titulo: "Entre las startups de IA con mayor proyección en España",
    logo: logoElReferente,
    extraLogo: null,
    objetivo: "Sparkling Tech Solutions ha sido incluida por El Referente entre las Top 25 Startups de Inteligencia Artificial a tener en cuenta para 2026. Un reconocimiento que nos posiciona como referente emergente en IA, neurotecnología y soluciones digitales avanzadas a nivel nacional."
  },
  {
    category: "Reconocimientos",
    program: "Café con ENISA",
    convocatoria: "2025",
    fechaInicio: "13/12/2025",
    titulo: "Participación en evento nacional de emprendimiento e innovación",
    logo: logoENISA,
    extraLogo: null,
    objetivo: "Sparkling Tech Solutions fue invitada a participar en el evento Café con ENISA, un encuentro nacional que reúne a startups, inversores y agentes del ecosistema emprendedor. Nuestra participación puso en valor la visión estratégica de la compañía y su experiencia en innovación tecnológica desde el ámbito universitario y empresarial."
  },
  /*{
    category: "Reconocimientos",
    program: "Entrevista en el programa de Televisión Canaria",
    convocatoria: "2025",
    fechaInicio: "25/11/2025",
    titulo: "Entrevista a Maica Amador, CEO de Sparkling Tech Solutions, en Televisión Canaria desde la Biblioteca de la ULPGC",
    logo: logoTVC,
    extraLogo: logoULPGC,
    objetivo: "Maica Amador, CEO de Sparkling Tech Solutions, fue entrevistada para un reportaje de Televisión Canaria (TVC) grabado en la Biblioteca de la Universidad de Las Palmas de Gran Canaria. En la entrevista, compartió la visión y los proyectos de la compañía, destacando su papel como ejemplo de emprendimiento innovador y tecnológico surgido desde el ecosistema canario y su conexión con el ámbito universitario."
  },*/
  {
    category: "Reconocimientos",
    program: "Pymes en Expansión - Nuevos Mercados",
    convocatoria: "2025",
    fechaInicio: "24/11/2025",
    titulo: "Caso de éxito en internacionalización empresarial",
    logo: logoTribunaDeCanarias,
    extraLogo: logoCamaraDeComercioGC,
    extraLogo2: logoBBVA,
    extraLogo3: logoLaProvincia,
    objetivo: "Sparkling Tech Solutions participó como caso de éxito en la jornada Pymes en Expansión: crecer en nuevos mercados, organizada por la Cámara de Comercio de Gran Canaria y BBVA. Nuestra experiencia en internacionalización fue presentada como un factor clave para el crecimiento, la competitividad y la resiliencia empresarial."
  },
  {
    category: "Reconocimientos",
    program: "BEST Course Official Certificate of Collaboration",
    convocatoria: "2026",
    fechaInicio: "26/03/2026",
    titulo: "Colaboración con BEST (Board of European Students of Technology)",
    logo: logoBEST,
    objetivo: "Sparkling Tech Solutions recibió el Official Certificate of Collaboration de BEST (Board of European Students of Technology), reconociendo nuestra participación como empresa invitada en su programa de cursos. Un honor que valida nuestra visión innovadora y nuestra conexión con la comunidad estudiantil europea en tecnología y emprendimiento."
  },
  {
    category: "Casos de éxito",
    program: "Oficina Acelera Pyme - Ashotel",
    convocatoria: "2026",
    fechaInicio: "24/09/2026",
    titulo: "Caso de éxito en IA",
    logo: logoAshotel,
    extraLogo: logoOficinaAceleraPyme,
    objetivo:
      "Sparkling Tech Solutions ha sido seleccionada como caso de éxito por la Oficina Acelera Pyme de Ashotel, por el impacto de su IA social.",
  },
  {
    category: "Casos de éxito",
    program: "Red CIDE - Innovación Tecnológica",
    convocatoria: "2025",
    fechaInicio: "24/11/2025",
    titulo: "Empresa innovadora asesorada por la Red CIDE",
    logo: logoRedCIDE,
    extraLogo: null,
    objetivo: "Sparkling Tech Solutions forma parte de la Red CIDE, recibiendo asesoramiento estratégico para el desarrollo de soluciones tecnológicas inmersivas, inteligentes y accesibles. Este acompañamiento ha sido clave para impulsar proyectos de I + D + i, fortalecer la hoja de ruta empresarial y conectar con el ecosistema de innovación de Canarias."
  },
  {
    category: "Casos de éxito",
    program: "Canarias Excelencia Tecnológica",
    convocatoria: "2025",
    fechaInicio: "24/11/2025",
    titulo: "Empresa integrada en el ecosistema CET",
    logo: logoCET,
    extraLogo: null,
    objetivo: "Sparkling Tech Solutions está vinculada a Canarias Excelencia Tecnológica, formando parte de un clúster que promueve la excelencia, la transferencia de conocimiento y la competitividad del sector tecnológico canario, en colaboración con universidades, centros de investigación y empresas innovadoras."
  },
  {
    category: "Casos de éxito",
    program: "FEMETE - Caso de Éxito",
    convocatoria: "2025",
    fechaInicio: "24/11/2025",
    titulo: "Empresa referente en transformación digital",
    logo: logoFEMETE,
    extraLogo: null,
    objetivo: "Sparkling Tech Solutions ha sido reconocida como caso de éxito por FEMETE, en el marco de su programa de impulso a la transformación digital. Este reconocimiento destaca el avance de la compañía en la optimización de procesos, la mejora de su presencia digital y el fortalecimiento de su posicionamiento como empresa tecnológica innovadora."
  },
  {
    category: "Casos de éxito",
    program: "Oficina Acelera Pyme - FEMEPA",
    convocatoria: "2025",
    fechaInicio: "24/11/2025",
    titulo: "Caso de éxito en digitalización empresarial",
    logo: logoOficinaAceleraPyme,
    extraLogo: logoFemepa,
    objetivo: "Sparkling Tech Solutions ha sido seleccionada como caso de éxito por la Oficina Acelera Pyme de FEMEPA, por el impacto de su proceso de digitalización. El acompañamiento recibido ha permitido mejorar la gestión de proyectos, reforzar la estrategia digital y aumentar la visibilidad y competitividad de la empresa."
  }
];

const groupedProjectsPremio = projectsPremio.reduce((acc, project) => {
  const cat = project.category || "Otros";
  if (!acc[cat]) acc[cat] = [];
  acc[cat].push(project);
  return acc;
}, {});

const categoryColors = {
  "Nacionales": "section-nacionales",
  "Premios": "section-premios",
  "Reconocimientos": "section-reconocimientos",
  "Casos de éxito": "section-casos",
};



export default function MasAlla() {
  // Inicia AOS una sola vez
  useEffect(() => {
    AOS.init({
      duration: 800, // duración de las animaciones en ms
      once: true,    // anima solo la primera vez
      disable: () => window.matchMedia('(prefers-reduced-motion: reduce)').matches,
    });
  }, []);

  return (
    <div className="masalla relative min-h-screen">
      <GlassFilter />
      
      <StripeLikeGradientShader />

      {/* Container for Content */}
      <div className="relative z-10 w-full">

        {/* ─────────────── Hero ─────────────── */}
        <section className="hero relative z-10" data-aos="fade-up">
          {/* No global gradient blur here anymore */}

          <div className="hero__content masalla__container" data-aos="fade-in">
            <div className="hero__grid">
              <h1 className="hero__title" data-aos="zoom-in">
                Más allá de la I + D + i: donde la investigación se convierte en impacto real.
              </h1>

              <div className="hero__side" data-aos="fade-left">
                <p className="hero__subtitle">
                   En <strong>Sparkling Tech Solutions</strong> la I + D + i es nuestro motor: unimos ciencia y creatividad para transformar conocimiento en valor social.
                   <span className="block mb-4 text-sm font-bold tracking-[0.1em] text-white mt-4">I + D + i (Investigación, Desarrollo e Innovación)</span>
                </p>

                <a
                  href="/contacto"
                  className="lit-up-button"
                  data-aos="fade-up"
                >
                  <div className="lit-up-border" />
                  <div className="lit-up-content">
                    Pregúntanos
                  </div>
                </a>
              </div>
            </div>
          </div>
        </section>


        {/* ───────── Proyectos destacados ───────── */}
        <section className="projects relative z-10">
          {/* Header removed as requested */}

          {/* Sección Nacionales */}
          <section className="category-section section-nacionales" data-aos="fade-up">
             <div className="masalla__container">
               <h2 className="category-title">Proyectos Nacionales</h2>
               <div className="projects-grid-legacy">
                 {projects.map((p, i) => (
                   <div key={i} className="project-item" data-aos="fade-up">
                     <h3 className="project-card__program-outside">{p.program}</h3>
                     {p.subvencion && <p className="project-card__subvencion-outside"><i>{p.subvencion}</i></p>}
                     
                      <GlassEffect className="project-card flex flex-col h-full rounded-3xl p-10 bg-white backdrop-blur-md border border-white/50 shadow-lg transition-transform hover:-translate-y-1 hover:shadow-xl">
                        <div className="project-card__body">
                          <p className="project-intro__objetivo">
                            <strong>{p.titulo}</strong><br />
                            {p.objetivo}
                          </p>

                          <details className="project-details">
                            <summary>Más información</summary>
                            <ul className="project-details__list">
                              {p.convocatoria && <li><strong>Convocatoria:</strong> {p.convocatoria}</li>}
                              {p.expediente && <li><strong>Expediente:</strong> {p.expediente}</li>}
                              {p.fechaInicio && <li><strong>Fecha de inicio:</strong> {p.fechaInicio}</li>}
                              {p.duracion && <li><strong>Duración:</strong> {p.duracion}</li>}
                              {p.link && <li><strong>Enlace:</strong> <a href={p.link} target="_blank" rel="noopener noreferrer">{p.link}</a></li>}
                              {p.ayuda && <li><strong>Ayuda:</strong> {p.ayuda}</li>}
                            </ul>
                          </details>
                        </div>

                        <div className="project-card__footer">
                          {p.logo && <img src={p.logo} alt="Logo principal" />}
                          {p.extraLogo && <img src={p.extraLogo} alt="Logo adicional" className="project-card__extra-logo" />}
                          {p.extraLogo2 && <img src={p.extraLogo2} alt="Logo adicional 2" className="project-card__extra-logo" />}
                          {p.extraLogo3 && <img src={p.extraLogo3} alt="Logo adicional 3" className="project-card__extra-logo" />}
                        </div>
                      </GlassEffect>
                   </div>
                 ))}
               </div>
             </div>
          </section>

          {/* Sección Premios y Reconocimientos agrupada */}
          {Object.entries(groupedProjectsPremio).map(([category, list]) => (
            <section key={category} className={`category-section ${categoryColors[category] || ""}`} data-aos="fade-up">
              <div className="masalla__container">
                <h2 className="category-title">{category}</h2>
                <div className="projects-grid-legacy">
                  {list.map((p, i) => (
                    <div key={i} className="project-item" data-aos="fade-up">
                      <h3 className="project-card__program-outside">{p.program}</h3>
                      {p.subvencion && <p className="project-card__subvencion-outside"><i>{p.subvencion}</i></p>}

                      <GlassEffect className="project-card flex flex-col h-full rounded-3xl p-10 bg-white backdrop-blur-md border border-white/50 shadow-lg transition-transform hover:-translate-y-1 hover:shadow-xl">
                        <div className="project-card__body">
                          <p className="project-intro__objetivo">
                            <strong>{p.titulo}</strong><br />
                            {p.objetivo}
                          </p>
                          
                          <details className="project-details">
                            <summary>Más información</summary>
                            <ul className="project-details__list">
                              {p.convocatoria && <li><strong>Convocatoria:</strong> {p.convocatoria}</li>}
                              {p.fechaInicio && <li><strong>Fecha de inicio:</strong> {p.fechaInicio}</li>}
                            </ul>
                          </details>
                        </div>

                        <div className="project-card__footer">
                           {p.logo && <img src={p.logo} alt="Logo principal" />}
                           {p.extraLogo && <img src={p.extraLogo} alt="Logo adicional" className="project-card__extra-logo" />}
                           {p.extraLogo2 && <img src={p.extraLogo2} alt="Logo adicional 2" className="project-card__extra-logo" />}
                           {p.extraLogo3 && <img src={p.extraLogo3} alt="Logo adicional 3" className="project-card__extra-logo" />}
                        </div>
                      </GlassEffect>
                    </div>
                  ))}
                </div>
              </div>
            </section>
          ))}
        </section>
      </div> {/* End of Gradient Wrapper */}
    </div>
  );
}
